export const HEADING_TITLES = {
  ACCESSORIES: 'specs',
  TIRES: {
    SIZES: 'tire sizes',
    SPECS: 'tire specs'
  },
  WHEELS: {
    SIZES: 'wheel sizes',
    SPECS: 'wheel specs'
  }
};

export const SPECS = {
  ACCESSORIES: [
    {
      label: 'LENGTH',
      productProp: 'size'
    },
    {
      label: 'LINE',
      productProp: 'lineName'
    },
    {
      label: 'BLADE TYPE',
      productProp: 'bladeType'
    },
    {
      label: 'VENDOR PART #',
      productProp: 'manufacturerAID'
    },
    {
      label: 'VENDOR UPC/GTIN',
      productProp: 'gtin'
    },
    {
      label: 'PACKAGE QTY',
      productProp: 'unitOfMeasureContents'
    },
    {
      label: 'RIM DIAMETER',
      productProp: 'rimDiameter'
    },
    {
      label: 'COLOR',
      productProp: 'colorName'
    },
    {
      label: 'TYPE',
      productProp: 'chainType'
    },
    {
      label: 'SUB TYPE',
      productProp: 'chainSubType'
    }
  ],
  TIRES: [
    {
      id: 'section.width',
      label: 'SECTION WIDTH',
      productProp: 'tireCrossSection'
    },
    {
      id: 'aspect.ratio',
      label: 'ASPECT RATIO',
      productProp: 'tireAspectRatio'
    },
    {
      id: 'rim.diameter',
      label: 'RIM DIAMETER',
      productProp: 'tireWheelRimDiameter',
      unit: '"'
    },
    {
      id: 'overall.diameter',
      label: 'OVERALL DIAMETER',
      productProp: 'tireDiameter',
      unit: '"'
    },
    {
      id: 'rim.width.range',
      label: 'RIM WIDTH RANGE',
      productProp: 'widthRange',
      unit: '"'
    },
    {
      id: 'weight',
      label: 'WEIGHT',
      productProp: 'grossWeight',
      unit: ' LBS'
    },
    {
      id: 'tread.depth',
      label: 'TREAD DEPTH',
      productProp: 'treadDepth',
      unit: '"'
    },
    {
      id: 'load.index',
      label: 'LOAD INDEX',
      productProp: 'loadIndex'
    },
    {
      id: 'load.range',
      label: 'LOAD RANGE',
      productProp: 'loadRange'
    },
    {
      id: 'max.psi',
      label: 'MAX PSI',
      productProp: 'maxAirPressure',
      unit: ' PSI'
    },
    {
      id: 'speed.rating',
      label: 'SPEED RATING',
      productProp: 'speedRating'
    },
    {
      id: 'sidewall.description',
      label: 'SIDEWALL DESC.',
      productProp: 'sideWallDescriptionName'
    },
    {
      id: 'warranty',
      label: 'WARRANTY',
      productProp: 'manufacturerMileageWarranty'
    },
    {
      id: 'vpn',
      label: 'VPN',
      productProp: 'manufacturerAID'
    },
    {
      id: 'gtin',
      label: 'GTIN',
      productProp: 'gtin'
    }
  ],
  WHEELS: [
    {
      id: 'rim.diameter',
      label: 'RIM DIAMETER',
      productProp: 'wheelRimDiameter',
      unit: '"'
    },
    {
      id: 'rim.diameter',
      label: 'RIM WIDTH',
      productProp: 'wheelWidth',
      unit: '"'
    },
    {
      id: 'bolt.pattern',
      label: 'BOLT PATTERN',
      productProp: 'boltPatternVal'
    },
    {
      id: 'offset',
      label: 'OFFSET',
      productProp: 'offset'
    },
    {
      id: 'hub.bore.size',
      label: 'HUB BORE SIZE',
      productProp: 'hubBore'
    },
    {
      id: 'weight',
      label: 'WEIGHT',
      productProp: 'grossWeight',
      unit: ' LBS'
    },
    {
      id: 'vendor.finish',
      label: 'VENDOR FINISH',
      productProp: 'vendorFinish'
    },
    {
      id: 'number.of.bolts',
      label: 'NUMBER OF BOLTS',
      productProp: 'boltsQty'
    },
    {
      id: 'load.capacity',
      label: 'LOAD CAPACITY',
      productProp: 'loadCapacity',
      unit: ' LBS'
    },
    {
      id: 'vpn',
      label: 'VPN',
      productProp: 'manufacturerAID'
    },
    {
      id: 'gtin',
      label: 'GTIN',
      productProp: 'gtin'
    }
  ]
};
